import { render } from "./ManagerForms.html?vue&type=template&id=38b8f52c&external"
import script from "./ManagerForms.vue?vue&type=script&lang=js"
export * from "./ManagerForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__